<div class="dialog-content">
  <p>{{ _dialogData.message | async }}</p>
</div>
<div class="form-action-buttons">
  <p-button
    [label]="(_dialogData.rejectLabel | async) ?? 'Annuleren'"
    [icon]="_dialogData.rejectIcon"
    severity="secondary"
    (onClick)="handleCancel()"
  />
  <p-button
    [label]="(_dialogData.acceptLabel | async) ?? 'OK'"
    [severity]="_dialogData.severity"
    [icon]="_dialogData.acceptIcon"
    (onClick)="handleSubmit()"
  />
</div>
